module.exports = __webpack_public_path__ + "static/media/highlights-section-img.ecc14edd.png";